import React from 'react';
import AsyncPage from './async';
import DefaultBusinessLayout from '../../../../components/layout/DefaultBusinessLayout';

export default [
  <DefaultBusinessLayout
    key="/business/user/forgot-password"
    exact
    path="/business/user/forgot-password"
    component={AsyncPage}
  />,
];
